import { API } from '../../utils/globalApiServices';

export async function searchContentService({ input }) {
  const url = `/smart-mentor/search/?input=${input}`;
  const { data } = await API.get(url);
  return data;
}
